<script lang="ts">
	import { invalidateAllPrices } from '$lib/state/reactiveProduct.svelte';
	import log from '$lib/utils/log';
	import { onMount } from 'svelte';

	function registerCallbacks() {
		window.friendbuyAPI.push([
			'subscribe',
			'couponReceived',
			async function (couponCode: string) {
				try {
					await fetch('/api/referralCode', {
						method: 'POST',
						body: JSON.stringify({ couponCode })
					});
					invalidateAllPrices();
				} catch (e) {
					log.scope('Friendbuy').exception(e, { event: 'couponReceived' });
				}
			}
		]);

		window.friendbuyAPI.push([
			'subscribe',
			'widgetActionTriggered',
			async function (action: { actionName: string; email: string }) {
				if (action.actionName !== 'friendEmailCaptured') return;

				try {
					await fetch('/api/friendbuy', {
						method: 'POST',
						body: JSON.stringify({ email: action.email })
					});
				} catch (e) {
					log.scope('Friendbuy').exception(e, { event: 'widgetActionTriggered' });
				}
			}
		]);
	}

	onMount(() => {
		registerCallbacks();
	});
</script>

<svelte:head>
	<script>
		window['friendbuyAPI'] = window['friendbuyAPI'] || [];
		window['friendbuyAPI'].merchantId = 'a5424db9-fd23-4cb5-8863-09c9b0de6f8c';
		window['friendbuyAPI'].push(['merchant', window['friendbuyAPI'].merchantId]);
	</script>
</svelte:head>
